/** Matches `server/src/comments/controllers/validation.ts`. */
export const COMMENT_MAX_LENGTH = 10000;
